var _circle, _path, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2131 7.54517C13.0003 7.54517 11.1699 11.3598 11.1699 13.8815C11.1699 15.7662 11.4431 15.2116 10.3999 17.5107C9.12594 20.787 14.2489 22.1261 17.2131 22.1261C20.1763 22.1261 25.2993 20.787 24.0262 17.5107C22.983 15.2116 23.2562 15.7662 23.2562 13.8815C23.2562 11.3598 21.4249 7.54517 17.2131 7.54517Z",
    stroke: "#12171C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4078 24.644C18.1781 26.0175 16.2599 26.0338 15.0186 24.644",
    stroke: "#12171C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.6031,
    cy: 10.3953,
    r: 2.85013,
    fill: "#FF3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoti);
export default __webpack_public_path__ + "static/media/noti.8433714a39c79a55ed14398f09e199b6.svg";
export { ForwardRef as ReactComponent };